import type { ImportGlobFunction } from "vite";
import { isGlobInImportMeta } from "../../schema/utils/isGlobInImportMeta.js";
import type { RegExpWithGroups } from "../../utils/RegExpWithGroups.js";

let icons: Record<string, string> = {};

if (isGlobInImportMeta()) {
	icons = (import.meta as ImportMeta & { glob: ImportGlobFunction }).glob<string>("./*.svg", {
		eager: true,
		query: "raw",
		import: "default",
	});
} else {
	const { glob, readFile } = await import(/* @vite-ignore */ "fs/promises");
	const path = await import(/* @vite-ignore */ "path");
	for await (const fullPath of glob(path.join(import.meta.dirname, "./*.svg"))) {
		icons[path.parse(fullPath).base] = await readFile(fullPath, "utf-8");
	}
}

const regex = /(?<name>[^/]+)\.svg$/u as RegExpWithGroups<{ name: string }>;

export const iconMap = Object.fromEntries(
	Object.entries(icons).map(([path, content]) => {
		const match = regex.exec(path);
		if (!match) {
			throw new Error(`Invalid icon path: ${path}`);
		}
		return [match.groups.name, content];
	}),
);
